const googleTag = (eventName, params) => {
  const env = process.env.NODE_ENV
  const safeWindow = typeof window !== "undefined" ? true : false
  // const isGtag = typeof gtag !== "undefined" ? true : false

  if (env === "development") {
    console.log("====== development =======")
    console.log(`env: ${env}`)
    console.log(`event ${eventName} fired`)
    console.log(params)
  }

  if (env === "production") {
    safeWindow && gtag("event", eventName, params)
  }
}

export default googleTag
